import styled from "styled-components";
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 2rem;
  border-bottom: 1px solid #ddd;
  margin: 1rem 2rem;
`;
export const ContainerPetName = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const PetName = styled.h5`
  margin: 0;
  color: #123559;
  margin-bottom: 0.5rem;
`;

export const PetDetail = styled.div`
  color: #aaa;
  display: flex;
  & > p {
    color: #123559;
    margin: 0 0.5rem;

    width: fit-content;
  }
`;
